// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3O_DX","delete":"styles_delete__14tHK","update":"styles_update__1Tjke","add":"styles_add__2nVQ2"};